
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import ProgramProfile from '@/components/programs/ProgramProfile.vue';
import BatchUpdateModal from '@/components/programs/BatchUpdateModal.vue';

import userx from '@/store/modules/userx';
import programx from '@/store/modules/programx';

import { SoftwareType, ProgramData } from '@/store/models.def';

@Component({
	components: {
		BatchUpdateModal,
	},
})
export default class AllPrograms extends Vue {
	@Prop() public value!: ProgramData | null;

	public get groupedPrograms() {
		return programx.groupedPrograms;
	}
	public get defaultProgram(): ProgramData | null {
		return this.groupedPrograms.sql[this.groupedPrograms.sql.length - 1];
	}

	public currentProgram: ProgramData | null = this.defaultProgram || null;

	@Watch('defaultProgram')
	public onDefaultProgramChange(
		val: ProgramData | null,
		oldValue: ProgramData | null,
	) {
		if (this.currentProgram === null) {
			this.currentProgram = val;
			this.emitInput();
		}
	}
	@Watch('value')
	public onValueChange(val: ProgramData | null, oldValue: ProgramData | null) {
		if (val) {
			if (!this.currentProgram || val.id !== this.currentProgram.id) {
				this.currentProgram = val;
			}
		}
	}

	public mounted() {
		if (this.currentProgram) { this.emitInput(); }
	}

	public onSelect(selected: ProgramData) {
		this.currentProgram = selected;
		this.emitInput();
	}

	public emitInput() {
		this.$emit('input', JSON.parse(JSON.stringify(this.currentProgram)));
	}

	public downloadAllPrograms() {
		const allPrograms: ProgramData[] = [];
		for (const softwareType in this.groupedPrograms) {
			if (this.groupedPrograms.hasOwnProperty(softwareType)) {
				allPrograms.push(...this.groupedPrograms[softwareType as SoftwareType]);
			}
		}

		const dataStr = JSON.stringify(allPrograms, null, 2);
		const blob = new Blob([dataStr], { type: 'application/json' });
		const url = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = url;
		link.download = `programs-${new Date().toISOString().split('T')[0]}.json`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	}

	public openBatchUpdate() {
		const modal = this.$refs.batchUpdateModal as BatchUpdateModal;
		if (modal) {
			modal.show();
		}
	}
}
